/** @format */
import React, { useEffect } from "react";
import ScrollReveal from "scrollreveal"; // Import ScrollReveal
import {
  FaHome,
  FaInfoCircle,
  FaImages,
  FaComments,
  FaDownload,
  FaMapMarkerAlt,
  FaEnvelope,
  FaGlobe,
} from "react-icons/fa";
import { Link } from "react-scroll";

import logo from "../assets/LogoNoir.png";

export const Footer = () => {
  useEffect(() => {
    // Initialize ScrollReveal
    const sr = ScrollReveal({
      origin: "bottom", // Change this based on your preferred direction
      distance: "30px",
      duration: 500,
      delay: 100,
      easing: "ease-in-out",
    });

    // Reveal elements
    sr.reveal(".footer-item", { interval: 100 }); // Reveals items with class 'footer-item'
    sr.reveal(".footer-contact", { interval: 100 }); // Reveals contact items
  }, []);

  return (
    <footer className="bg-white-100 text-black-800 text-center p-4 border-t-2 border-green-800 md:py-0 sm:pt-0">
      <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-24">
        {/* Navigation Links */}
        <div className="p-4 rounded-lg flex flex-col items-center md:items-start">
          <h3 className="text-2xl mb-2">Plan&Drive</h3>
          <div className="flex flex-col items-start md:items-start space-y-2">
            <Link
              to="home"
              smooth={true}
              duration={500}
              className="flex items-center space-x-2 hover:text-green-800 footer-item cursor-pointer"
            >
              <FaHome />
              <span>Home</span>
            </Link>
            <Link
              to="presentation"
              smooth={true}
              duration={500}
              className="flex items-center space-x-2 hover:text-green-800 footer-item cursor-pointer"
            >
              <FaInfoCircle />
              <span>Présentation</span>
            </Link>
            <Link
              to="galeries"
              smooth={true}
              duration={500}
              className="flex items-center space-x-2 hover:text-green-800 footer-item cursor-pointer"
            >
              <FaImages />
              <span>Galeries</span>
            </Link>
            <Link
              to="telechargements"
              smooth={true}
              duration={500}
              className="flex items-center space-x-2 hover:text-green-800 footer-item cursor-pointer"
            >
              <FaDownload />
              <span>Téléchargements</span>
            </Link>
            <Link
              to="contact"
              smooth={true}
              duration={500}
              className="flex items-center space-x-2 hover:text-green-800 footer-item cursor-pointer"
            >
              <FaComments />
              <span>Contact</span>
            </Link>
          </div>
        </div>

        {/* Contact Information */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-12 p-4 rounded-lg bg-white-500 footer-contact">
          {" "}
          {/* Added class */}
          <div className="flex items-center flex-col">
            <FaMapMarkerAlt className="mb-2 text-2xl" />
            <p>Routes des Ecoles 123</p>
            <p>1937 Orsières</p>
            <p>027 - 783 50 50</p>
          </div>
          <div className="flex items-center flex-col">
            <FaMapMarkerAlt className="mb-2 text-2xl" />
            <p>Rue de Verdan 9A</p>
            <p>1920 Martigny</p>
            <p>027 - 722 25 50</p>
          </div>
          <div className="flex items-center flex-col">
            <FaEnvelope className="mb-2 text-2xl" />
            <a href="mailto:info@terrettaz.ch" className="text-green-800">
              info@terrettaz.ch
            </a>
          </div>
          <div className="flex items-center flex-col">
            <FaGlobe className="mb-2 text-2xl" />
            <a
              href="https://terrettaz.ch"
              className="text-green-800"
              target="_blank"
              rel="noreferrer"
            >
              www.terrettaz.ch
            </a>
          </div>
        </div>
      </div>

      {/* Footer bottom */}
      <div className="mt-4 flex flex-col items-center">
        <a
          href="https://terrettaz.ch"
          className="text-green-800 hover:underline cursor-pointer"
          target="_blank"
          rel="noreferrer"
        >
          <img src={logo} alt="Logo" className="w-36 object-contain mb-4" />
        </a>
        <p className="text-sm">© 2024 Terrettaz Informatique SA</p>
      </div>
    </footer>
  );
};

export default Footer;
